import { useNavigate } from "react-router-dom";

const NoAccessPage = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div className="no-access-main">
      <h2>Geen Toegang</h2>
      <div className="left-column"></div>
      <div>
        Je hebt geen toegang tot deze pagina.
        <br />
        Neem contact op met de beheerder als je denkt dat dit een fout is.
      </div>
      <button className="back-button" onClick={handleBackToLogin}>
        Terug naar inloggen
      </button>
    </div>
  );
};

export default NoAccessPage;
